import { themeStyle } from '@repo/ui/theming';
import { H4 } from '@repo/ui-kit/components/core/Typography';
import styled from 'styled-components';

import { FlexRow } from 'styles/layouts';

export const DialogTitle = styled(FlexRow)`
  border-bottom: 1px solid ${themeStyle.inkLight};
`;

export const Container = styled.div``;

export const Title = styled(H4)``;

export const SubmitArea = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column-reverse;
`;

export const SelectItemWrapper = styled.div`
  /* uikit does not have a large select so this is needed as workaround */
  & [class*='item'][class*='select-item'] {
    height: auto;
  }
`;
